import { LazyLoad } from '@petconsole/pure-fe-mui';

const SitterAdmin = LazyLoad(() => import('./SitterAdmin'));

export { SitterAdmin };
